<template>
  <a
    href="#"
    :class="{ muted: !isActiveShareBtn, 'text-gray-500  hover:text-gray-200': isGalleryModal}"
    
    v-if="showShareBtn"
    @click.prevent="clickAddShareBtn"
  >
    <aw-icon icon="share-list" class="w-5 h-5 "></aw-icon>
    <span v-if="!isGalleryModal">
      {{ $t('Add to share list') }}
    </span>
  </a>
</template>

<script>
import ShareButton from '../../mixins/ShareButton'

export default {
  mixins: [ShareButton]
}
</script>

<style lang="scss" scoped></style>
